import { useQuery } from '@tanstack/react-query';
import { api } from 'services/api';
import { User } from 'shared/entities';

export const useCurrentBaseUser = () => {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const response = await api.get<User>('/users/baseUser');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
